import React from 'react';
import Header from '../components/Header';
import Footer from './Footer';

interface Props {
  children: React.ReactNode;
  hideHeaderButtons?: boolean;
}

export const Layout: React.FC<Props> = ({ children, hideHeaderButtons }) => {
  const noop = () => {};

  return (
    <>
      <Header
        onOpenFolder={noop}
        onToggleSort={noop}
        onCopy={noop}
        pickedCount={0}
        sortMode="name"
        hideButtons={hideHeaderButtons}
      />
      {children}
      <Footer />
    </>
  );
};
